/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/common.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers common to all components.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Saturday, September 15, 2018 - 10:05 PM (CST)
 *  
 *  Notes:
 *      09/15/2018  NJN     Working on clean up to split out or eliminate code.
 *  
 *  Revisions:
 *      09/15/2018  NJN     File Created
 *      09/15/2018  NJN     Cleaned out action types from other components.
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    APP_LOAD,
    SIDEBARSHOW,
    SIDEBARUNFOLDABLE,
    ASIDESHOW,
    REDIRECT,
    LOGOUT,
    LOGIN,
    REGISTER_SUBMIT,
    REDIRECT_ADDCANCEL,
    REDIRECT_EDIT,
    COMMON_UPDATE_FILTER,
    COMPONENT_UNLOAD,
    OPEN_CMSSELECT,
    CLOSE_CMSSELECT,
    LOAD_CMSSELECT,
    FOLDER_CONTENTS_LOADED,
    SITE_CREATECART,
    SITE_ADDITEM,
    SITE_UPDATEITEM,
    SITE_REMOVEITEM,
    SITE_GETCHECKOUT
} from '../constants/actionTypes';

import {
    SYSTEMLIST_VIEW_LISTITEMS
} from '../constants/actionTypeSystemLists';

const defaultState = {
    appName: 'Advarion ReactReduxCoreUI',
    token: null,
    viewChangeCounter: 0,
    asideShow: false,
    cart: {}
};

// eslint-disable-next-line
export default (state = defaultState, action) => {
    switch (action.type) {
        case APP_LOAD:
            return {
                ...state,
                token: action.token || null,
                appLoaded: true,
                currentUser: action.payload ? action.payload.username : null
            };
        case SIDEBARSHOW:
            return {
                ...state,
                sidebarShow: action.sidebarShow
            }
        case SIDEBARUNFOLDABLE:
            return {
                ...state,
                sidebarUnfoldable: action.sidebarUnfoldable
            }
        case ASIDESHOW:
            return {
                ...state,
                asideShow: action.asideShow
            }
        case REDIRECT:
            return { ...state, redirectTo: null };
        case COMMON_UPDATE_FILTER:
            return { ...state, [action.key]: action.value };
        case LOGOUT:
            return { 
                ...state, 
                redirectTo: '/',
                token: null, 
                currentUser: null,
                currentUserID: null,
                currentUserFullName: null,
                roles: null
             };
        case REDIRECT_ADDCANCEL:
            return {
                ...state,
                redirectTo: action.redirect
            };
        case REDIRECT_EDIT:
            return {
                ...state,
                redirectTo: action.redirect + '/' + action.id
            };
        case LOGIN:
            return {
                ...state,
                redirectTo: action.error ? null : '/',
                token: action.error ? null : action.payload.access_token,
                currentUser: action.error ? null : action.payload.username,
                currentUserID: action.error ? null : action.payload.userid,
                currentUserFullName: action.error ? null : action.payload.firstname + ' ' + action.payload.lastname,
                roles: action.error ? null: action.payload.roles
            };
        case REGISTER_SUBMIT:
            return {
                ...state,
                redirectTo: action.error ? null : '/RegisterThanks',
            };

        case SYSTEMLIST_VIEW_LISTITEMS:
            return {
                ...state,
                systemlistid: action.systemlistid ? action.systemlistid : 0,
                systemlistparentid: action.systemlistparentid ? action.systemlistparentid : 0
            };

        case OPEN_CMSSELECT:
            return {
                ...state,
                tagName: action.payload ? action.payload.tagName : '',
                type: action.payload ? action.payload.type : '',
                cmsselect: true
            }
        case CLOSE_CMSSELECT:
            return {
                ...state,
                tagname: '',
                type: '',
                cmsselect: false
            }
        case LOAD_CMSSELECT:
            return {
                ...state,
                folders: action.payload[0] ? action.payload[0].records : null,
                folderTree: action.payload[1] ? action.payload[1].records : null
            }
        case FOLDER_CONTENTS_LOADED:
            return {
                ...state,
                folderContents: action.payload[0] ? action.payload[0].records : null,
                folderid: action.payload[0] ? action.payload[0].folderid : 0
            }

        case COMPONENT_UNLOAD:
            return { ...state, viewChangeCounter: state.viewChangeCounter + 1 };
        case SITE_CREATECART:
            return {
                ...state,
                cart: action.payload ? action.payload : {}
            }
        case SITE_ADDITEM:
            return {...state}
        case SITE_UPDATEITEM:
            return {...state}
        case SITE_REMOVEITEM:
            return {...state}
        case SITE_GETCHECKOUT:
            return {...state}
        default:
            return state;
    }
};
